import React, {ReactNode} from 'react';
import {r} from "@/utils/responsive";

interface ButtonSpanProps extends React.HTMLAttributes<HTMLSpanElement> {
    children?: ReactNode;
    shadowColor?: string;
}

const ButtonSpan: React.FC<ButtonSpanProps> = ({className, children, shadowColor = "#5282FF", ...props}) => {
    return (
        <span
            {...props}
            style={{
                color: 'white',
                fontSize: r.vmax(28),
                lineHeight: r.vmax(36),
                textShadow: `0 ${r.vmax(4)} ${r.vmax(30)} ${shadowColor}`,
                ...props.style
            }}
        >
{children}
    </span>
    );
};

export default ButtonSpan;
